import { useEffect } from 'react';

function useSaveModalShortcut(onSave,) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // For Windows/Linux: Ctrl+S
      // For Mac: Meta+S (Cmd+S)
      if ((event.ctrlKey || event.metaKey) && (event.key === 's') ) {
        event.preventDefault(); // Prevent the browser's default "save page" behavior
        if (onSave) onSave();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    // Cleanup when component unmounts
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onSave]);
}

export default useSaveModalShortcut